import {
  ReceivedInvoiceOperationStatus,
  ReceivedInvoicesSearchQuery,
  TReceivedInvoiceCondition,
} from '@/context/services/invoice/type';
import { toISODateString } from 'date-util';

export const DEFAULT_RECEIVED_INVOICE_OPERATION_STATUS_IN: ReceivedInvoiceOperationStatus[] =
  ['not_started', 'applying', 'applied'];

export const getEmptyReceivedInvoiceSearchValues = (
  isReconciliationStatusVisible: boolean
): TReceivedInvoiceCondition => ({
  ap_payee_id_in: [],
  searchable_number_or_filename_cont: '',
  operation_status_in: [...DEFAULT_RECEIVED_INVOICE_OPERATION_STATUS_IN],
  pic_id_in: [],
  upload_type_in: [],
  uploaded_date: ['', ''],
  page: 1,
  due_date: ['', ''],
  total_amount_from: '',
  total_amount_to: '',
  ...(isReconciliationStatusVisible ? { reconciliation_status_in: [] } : {}),
});

export function convertToInvoiceFilterPayload(
  search: TReceivedInvoiceCondition
): ReceivedInvoicesSearchQuery {
  const {
    searchable_number_or_filename_cont,
    ap_payee_id_in,
    operation_status_in,
    reconciliation_status_in,
    pic_id_in,
    upload_type_in,
    uploaded_date,
    due_date,
    total_amount_from,
    total_amount_to,
    page,
  } = search;

  const isEmptyArray = (value: string[]) =>
    Array.isArray(value) && value.length === 0;

  const result: ReceivedInvoicesSearchQuery = {};

  if (searchable_number_or_filename_cont) {
    result.searchable_number_or_filename_cont =
      searchable_number_or_filename_cont;
  }

  if (ap_payee_id_in && !isEmptyArray(ap_payee_id_in)) {
    result.ap_payee_id_in = ap_payee_id_in;
  }

  if (operation_status_in && !isEmptyArray(operation_status_in)) {
    result.operation_status_in = operation_status_in;
  }

  if (reconciliation_status_in && !isEmptyArray(reconciliation_status_in)) {
    result.reconciliation_status_in = reconciliation_status_in;
  }

  if (pic_id_in && !isEmptyArray(pic_id_in)) {
    result.pic_id_in = pic_id_in;
  }

  if (upload_type_in && !isEmptyArray(upload_type_in)) {
    result.upload_type_in = upload_type_in;
  }

  if (page) {
    result.page = page;
  }

  if (uploaded_date && uploaded_date[0] !== '' && uploaded_date[1] !== '') {
    result.uploaded_at_gteq =
      uploaded_date[0] && toISODateString(uploaded_date[0]);
    result.uploaded_at_lteq =
      uploaded_date[1] && toISODateString(uploaded_date[1]);
  }

  if (due_date && due_date[0] !== '' && due_date[1] !== '') {
    result.due_date_from = due_date[0] && toISODateString(due_date[0]);
    result.due_date_to = due_date[1] && toISODateString(due_date[1]);
  }

  if (total_amount_from) {
    result.total_amount_from = total_amount_from;
  }

  if (total_amount_to) {
    result.total_amount_to = total_amount_to;
  }

  return result;
}
